import React, { useState, useMemo } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from '../config/axios';
import '../styles/Login.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const emailParam = useMemo(() => searchParams.get('email') || '', [searchParams]);

  const [email, setEmail] = useState(emailParam);
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const missingLink = !token || !emailParam;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post('/auth/reset-password', {
        email: email.trim().toLowerCase(),
        token,
        newPassword
      });
      setMessage(data.message || 'Password updated.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Set new password</h2>
        {missingLink ? (
          <>
            <p className="error-message">Invalid or missing reset link. Open the link from your email.</p>
            <p className="register-link">
              <Link to="/forgot-password">Request a new link</Link> · <Link to="/login">Login</Link>
            </p>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                readOnly={Boolean(emailParam)}
                style={emailParam ? { background: '#f5f5f5' } : undefined}
              />
            </div>
            <div className="form-group">
              <label>New password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
                placeholder="At least 6 characters"
              />
            </div>
            <div className="form-group">
              <label>Confirm password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={6}
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            {message && (
              <div
                className="error-message"
                style={{ background: '#e8f5e9', color: '#1b5e20', border: '1px solid #a5d6a7' }}
              >
                {message} Redirecting to login…
              </div>
            )}
            <button type="submit" disabled={loading || !!message} className="submit-btn">
              {loading ? 'Saving…' : 'Update password'}
            </button>
          </form>
        )}
        {!missingLink && (
          <p className="register-link">
            <Link to="/login">Back to login</Link>
          </p>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
